import { useState, useRef } from 'react'
import { Button } from 'react-bootstrap'

const ConfirmButton = ({ label, confirmLabel, loadingLabel, delay = 3000, ...props }) => {
  const timerRef = useRef(undefined)
  const [ready, setReady] = useState(false)
  const [loading, setLoading] = useState(false)
  const onClick = (e) => {
    if (loading) return;

    if (ready) {
      if (timerRef.ref) {
        clearTimeout(timerRef.ref)
        timerRef.ref = undefined
      }

      setLoading(true)
      props.onClick(e).then(() => {
        setLoading(false)
        setReady(false)
      })

    } else {
      setReady(true)
      setTimeout(() => {
        setReady(false)
      }, delay)
    }
  }

  return (
    <Button {...props} onClick={onClick}>
      {loading ? loadingLabel : (ready ? (confirmLabel ? confirmLabel : `Really ${label}?`) : label)}
    </Button>
  )
}

export default ConfirmButton
